import { SystemStyleObject } from '@chakra-ui/react'

import { tokenVar } from '../../theme/tokenVar'
import type { ColorScheme } from '../../types'

const tokens = {
  dark: {
    textSecondary: 'text.secondary',
    textTertiary: 'text.tertiary',
  },
  light: {
    textSecondary: 'light.text.secondary',
    textTertiary: 'light.text.tertiary',
  },
}

export const containerStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minW: 0,
  w: 'full',
}

export const actionsRowStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
}

export const actionButtonsStyles: SystemStyleObject = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
}

// Scrollbar thumb per scheme - the UA default scrollbar ignores the
// colorScheme entirely, so the scrollable list styles its own.
const SCROLLBAR_THUMB: Record<ColorScheme, string> = {
  dark: tokenVar('colors.border.strong'),
  light: tokenVar('colors.light.border.strong'),
}

export const listStyles = (
  colorScheme: ColorScheme,
  maxListHeight: string
): SystemStyleObject => ({
  display: 'flex',
  flexDirection: 'column',
  maxH: maxListHeight,
  overflowY: 'auto',
  // Standard properties (Firefox, Chrome 121+); WebKit pseudos as fallback.
  scrollbarWidth: 'thin',
  scrollbarColor: `${SCROLLBAR_THUMB[colorScheme]} transparent`,
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: SCROLLBAR_THUMB[colorScheme],
    borderRadius: '4px',
  },
})

export const messageStyles = (colorScheme: ColorScheme): SystemStyleObject => ({
  color: tokens[colorScheme].textSecondary,
  px: '10px',
  py: '8px',
  textStyle: 'caption',
})

export const loadingStyles: SystemStyleObject = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  py: '16px',
}

/** Single line with an ellipsis - a Tooltip shows the full label only when
 * the text actually overflows. Never wraps: multi-line rows made long
 * facility names illegible. */
export const rowLabelStyles: SystemStyleObject = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
}

export const rowSubtitleStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  color: tokens[colorScheme].textSecondary,
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textStyle: 'caption',
  whiteSpace: 'nowrap',
})

export const rowCaptionStyles = (
  colorScheme: ColorScheme
): SystemStyleObject => ({
  color: tokens[colorScheme].textTertiary,
  display: 'block',
  fontStyle: 'italic',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textStyle: 'caption',
  whiteSpace: 'nowrap',
})
